import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LoadingCM from "../components/loading";
import { SOCKET_OBJ_DATA } from "../helper/const";
import useSocket from "../hooks/use-socket";
import { useIndexedDB } from "react-indexed-db-hook";

export const StartExamPage = ({ phone_number = "", full_name = "" }) => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const { getAll } = useIndexedDB("answers");

  const getExamAnswersHandler = async () => {
    const db = (await getAll()).find((item) => item.exam === id);
    return db ? db.options : {};
  };
  const {
    socketConnections,
    closeSocket,
    onSocket,
    emitSocket,
    loading,
    setLoading,
  } = useSocket({
    headers: {
      token: localStorage.getItem("uuid"),
      phone_number,
    },
    setConnectionsError: setData,
  });

  useEffect(() => {
    if (!socketConnections) {
      return;
    }
    const [exam_id, package_id] = [...id?.split("__")];

    emitSocket(
      "getexam",
      JSON.stringify({
        exam_id,
        package_id,
      })
    );

    onSocket("getexam", async (data) => {
      setLoading(false);
      console.log(data);
      if(data.code == 564523){
        if (
          data.package_id == package_id &&
          data.exam_id == exam_id
        ) {
          const res = await getExamAnswersHandler();
          Object.keys(res).forEach((key) => {
            if (res[key] > 4) {
              delete res[key];
            }
          });
          emitSocket(
            "sendQuestion",
            JSON.stringify({
              package_id,
              exam_id,
              answers: res,
            })
          );
          if (data.finished) {
            setData({
              type: "success",
              message: "آزمون شما به اتمام رسید و آخرین پاسخنامه ی شما ثبت شد",
              code: 666666,
            });
            closeSocket();
          }
          return;
        }
        return;
    }
      setData(data);
    });
    return () => {
      closeSocket();
    };
  }, [id, socketConnections]);
  return (
    <>
      <>
        <div>
          {loading ? (
            <LoadingCM title="در حال اتصال" />
          ) : (
            SOCKET_OBJ_DATA[data.code]?.content?.({
              socket: socketConnections,
              data: { ...data, phone_number, full_name },
            })
          )}
        </div>
      </>
    </>
  );
};

export default StartExamPage;
